import { useLocation, useMatches } from "@remix-run/react"
import * as SentryRemix from "@sentry/remix"
import { useEffect } from "react"
import type { Sentry } from "../server/monitoring/sentry.ts"

export const SentryMonitoring = {
  init: (config: Sentry.Config) => {
    SentryRemix.init({
      dsn: config.dsn,
      environment: config.environment,
      release: config.release,
      integrations: [
        SentryRemix.browserTracingIntegration({
          useEffect,
          useLocation,
          useMatches,
        }),
        SentryRemix.replayIntegration({
          maskAllInputs: false,
          maskAllText: false,
        }),
      ],

      tracesSampleRate: 1,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1,
    })
  },
}

export const SentryClientScript = (props: Sentry.Config) => (
  <script dangerouslySetInnerHTML={{ __html: `window.SENTRY_CONFIG = ${JSON.stringify(props)}` }} />
)

declare global {
  interface Window {
    SENTRY_CONFIG: Sentry.Config | null
  }
}
